import moment from 'moment';

export const formatDate = (date) => {
  return moment
    .utc(date)
    .local()
    .format('MMM D h:mm A');
};
